import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

import 'swiper/css'

export default function (element, dataset = {}) {
  const {
    effect = 'slide',
    spaceBetween = 8,
    centeredSlides = true,
    slidesPerView = 'auto',
    lgEnabled = false,
    lgSpaceBetween = 24,
    lgSlidesPerView = 4,
    lgCenteredSlides = false,
    pagination = false,
  } = dataset

  function buildCustomPagination() {
    const paginationWrapper = element.querySelector('[data-swiper-pagination]')
    if (!paginationWrapper) return null

    const bullets = Array.from(paginationWrapper.children)

    return {
      el: paginationWrapper,
      clickable: true,
      bulletClass: 'swiper-pagination-item',
      bulletActiveClass: 'is-active',
      renderBullet(index, className) {
        const bullet = bullets[index]
        if (!bullet) return `<span class="${className}"></span>`
        bullet.classList.add(className)
        return bullet.outerHTML
      },
    }
  }

  const baseConfig = {
    modules: [Navigation],
    speed: 300,
    spaceBetween,
    slidesPerView,
    centeredSlides,
    enabled: true,
    breakpoints: {
      992: {
        spaceBetween: lgSpaceBetween,
        slidesPerView: lgSlidesPerView,
        centeredSlides: lgCenteredSlides,
        enabled: lgEnabled,
      },
      768: {
        enabled: false,
        centeredSlides: false,
      },
    },
  }

  const hasPagination = pagination === true || pagination === 'true'

  const swiperConfig = {
    ...baseConfig,
    effect,
    ...(hasPagination
      ? {
          modules: [...baseConfig.modules, Pagination],
          pagination: buildCustomPagination(),
        }
      : {}),
  }

  new Swiper(element.querySelector('.swiper'), swiperConfig)
}
